var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.03C0 9.49424 8.42 0 20.04 0C31.4 0 40 9.31397 40 19.97C40 32.3285 29.92 40 20 40C16.72 40 13.08 39.1187 10.16 37.3961C9.14 36.7752 8.28 36.3145 7.18 36.675L3.14 37.8768C2.12 38.1973 1.2 37.3961 1.5 36.3145L2.84 31.8277C3.06 31.2068 3.02 30.5458 2.7 30.025C0.98 26.8603 0 23.3951 0 20.03ZM26.6211 20.0521C26.6211 21.4542 27.7611 22.616 29.1811 22.616C30.6011 22.616 31.7411 21.4542 31.7411 20.0521C31.7411 18.63 30.6011 17.4883 29.1811 17.4883C27.7611 17.4883 26.6211 18.63 26.6211 20.0521ZM17.4023 20.0324C17.4023 21.4545 18.5423 22.5962 19.9623 22.6162C21.3823 22.6162 22.5223 21.4545 22.5223 20.0524C22.5223 18.6302 21.3823 17.4885 19.9623 17.4885C18.5623 17.4685 17.4023 18.6302 17.4023 20.0324ZM10.7397 22.6199C9.33969 22.6199 8.17969 21.4581 8.17969 20.056C8.17969 18.6339 9.31969 17.4922 10.7397 17.4922C12.1597 17.4922 13.2997 18.6339 13.2997 20.056C13.2997 21.4581 12.1597 22.5998 10.7397 22.6199Z",
    fill: "#EC923C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.dd1d9d14.svg";
export { ForwardRef as ReactComponent };